import { ButtonWebElementBase } from './ButtonWebElementBase';
import { getTestElement } from '../../../webdriver/PRIVATE_preact-webdriver';
import { findButton } from '@oracle/oraclejet-preact/UNSAFE_Button/testing';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';

/**
 * The component WebElement for [oj-c-button](../../jsdocs/oj-c.Button.html).
 * Do not instantiate this class directly, instead, use
 * [findButton](../functions/findButton.html).
 */
export class ButtonWebElement extends ButtonWebElementBase {
  /**
   * Perform a click on the button
   */
  doAction() {
    return this.click();
  }

  override async click(): Promise<void> {
    return findButton(byCss('*'), getTestElement(this)).doAction();
  }
}
